import './Massage.css';
import { useState, useEffect } from 'react';

export default function Massage({ text, animation, buttonAgree, setClose }) {
    const [textShwo, setTextShwo] = useState(text);


    useEffect(() => {
        setTextShwo(text);

        if (animation && text !== "") {
            const timeoutId = setTimeout(() => {
                setClose(); // Call the setClose function after 3 seconds
            }, 3000);

            return () => clearTimeout(timeoutId); // Cleanup timeout on unmount or dependency change
        }
    }, [text, animation, setClose]);

    return (
        <div className={textShwo === "" ? 'spin' : animation ? 'massage massage_animation' : 'massage'}>
            <p>{textShwo}</p>
            {buttonAgree && (
                <div>
                    <p onClick={() => setClose(false)}>ביטול</p>
                    <p onClick={() => buttonAgree()}>אישור</p>
                </div>
            )}
        </div>
    );
}
